import * as requestFromServer from "./languageApis";
import { toastService } from "../../../component/common/toast-messages/toast";

// services -> create services api
export const preferredLanguageApi =
  (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.languageService(dataToBeSent);
    if (response) {
      setTimeout(() => {
        window.location.reload();
      }, 500);
      toastService.success(response?.message);
      setLoading(false);
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };
